(function () {
  'use strict';
  if (window.__fizzyMessageStories) {
    window.__fizzyMessageStories.scan(document);
    return;
  }

  var instances = new Map();
  var preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  var activePlayback = null;

  function blurredImageURL(value) {
    try {
      var url = new URL(String(value || ''), window.location.href);
      var trustedHost = url.origin === window.location.origin && url.pathname.indexOf('/cdn/shop/') === 0;
      if (url.hostname === 'cdn.shopify.com') trustedHost = true;
      if (!trustedHost || !/^https?:$/.test(url.protocol)) return null;
      if (!/^fizzy-message-\d+-blurred\.png$/.test(url.pathname.split('/').pop())) return null;
      return url.href;
    } catch (_) { return null; }
  }

  function init(root) {
    if (instances.has(root)) return;
    var cleanups = [];
    var disposed = false;
    var stories = new Map();
    root.querySelectorAll('script[type="application/json"][data-fms-story]').forEach(function (script) {
      try {
        var story = JSON.parse(script.textContent || '{}');
        if (story.id && blurredImageURL(story.image)) stories.set(String(story.id), story);
      } catch (_) { /* The readable card remains available if its source payload is missing. */ }
    });
    function listen(target, event, handler, options) {
      if (!target) return;
      target.addEventListener(event, handler, options);
      cleanups.push(function () { target.removeEventListener(event, handler, options); });
    }

    var rail = root.querySelector('[data-fms-rail]');
    if (rail) {
      var cards = Array.from(rail.children).filter(function (card) { return card.matches('[data-fms-card]'); });
      var previous = root.querySelector('[data-fms-prev]');
      var next = root.querySelector('[data-fms-next]');
      var position = root.querySelector('[data-fms-position]');
      var announcement = root.querySelector('[data-fms-status]');
      var frame = 0;
      var announcementTimer = 0;
      function geometry() {
        var maximum = Math.max(0, rail.scrollWidth - rail.clientWidth);
        var left = Math.min(maximum, Math.max(0, rail.scrollLeft));
        var first = cards.length ? cards[0].getBoundingClientRect().left : 0;
        var offsets = cards.map(function (card) { return card.getBoundingClientRect().left - first; });
        return { maximum: maximum, left: left, offsets: offsets };
      }
      function update(announce) {
        frame = 0;
        if (disposed) return;
        var bounds = geometry();
        var index = 0;
        bounds.offsets.forEach(function (offset, candidate) {
          if (Math.abs(offset - bounds.left) < Math.abs((bounds.offsets[index] || 0) - bounds.left)) index = candidate;
        });
        var inset = parseFloat(window.getComputedStyle(rail).paddingInlineStart) || 0;
        if (previous) previous.disabled = !cards.length || bounds.left <= inset + 2;
        if (next) next.disabled = !cards.length || bounds.maximum - bounds.left < 2;
        if (position) position.textContent = cards.length ? (index + 1) + ' / ' + cards.length : '0 / 0';
        if (announce && announcement && cards.length) announcement.textContent = 'Showing story ' + (index + 1) + ' of ' + cards.length;
      }
      function move(direction) {
        var bounds = geometry();
        var stops = Array.from(new Set([0].concat(bounds.offsets.map(function (offset) {
          return Math.min(bounds.maximum, Math.max(0, offset));
        }), bounds.maximum)));
        var target = direction > 0 ? stops.find(function (stop) { return stop > bounds.left + 2; }) : stops.reverse().find(function (stop) { return stop < bounds.left - 2; });
        if (target === undefined) target = direction > 0 ? bounds.maximum : 0;
        rail.scrollTo({ left: target, behavior: preference.matches ? 'auto' : 'smooth' });
      }
      listen(previous, 'click', function () { move(-1); });
      listen(next, 'click', function () { move(1); });
      listen(rail, 'keydown', function (event) {
        if (event.target !== rail || (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight')) return;
        event.preventDefault();
        move(event.key === 'ArrowRight' ? 1 : -1);
      });
      listen(rail, 'scroll', function () {
        if (!frame) frame = window.requestAnimationFrame(function () { update(false); });
        window.clearTimeout(announcementTimer);
        announcementTimer = window.setTimeout(function () { update(true); }, 180);
      }, { passive: true });
      listen(rail, 'scrollend', function () { window.clearTimeout(announcementTimer); update(true); });
      if ('ResizeObserver' in window) {
        var resize = new ResizeObserver(function () { update(false); });
        resize.observe(rail);
        cleanups.push(function () { resize.disconnect(); });
      } else listen(window, 'resize', function () { update(false); }, { passive: true });
      cleanups.push(function () { window.cancelAnimationFrame(frame); window.clearTimeout(announcementTimer); });
      update(false);
    }

    var dialog = root.querySelector('[data-fms-viewer]');
    if (dialog) {
      var image = dialog.querySelector('[data-fms-viewer-image]');
      var well = dialog.querySelector('[data-fms-image-well]');
      var zoom = dialog.querySelector('[data-fms-zoom]');
      var close = dialog.querySelector('[data-fms-close]');
      var imageStatus = dialog.querySelector('[data-fms-image-status]');
      var guidance = dialog.querySelector('[data-fms-zoom-guidance]');
      var fullImage = dialog.querySelector('[data-fms-full-image]');
      var opener = null;
      function resetZoom() {
        if (well) { well.classList.remove('is-zoomed'); well.scrollLeft = 0; well.scrollTop = 0; }
        if (image) image.style.width = '';
        if (zoom) { zoom.setAttribute('aria-pressed', 'false'); zoom.textContent = 'Zoom in'; }
        if (guidance) guidance.hidden = true;
      }
      function imageReady() {
        if (image) image.hidden = false;
        if (well) well.setAttribute('aria-busy', 'false');
        if (imageStatus) imageStatus.hidden = true;
        if (zoom) zoom.disabled = false;
      }
      listen(image, 'load', imageReady);
      listen(image, 'error', function () {
        resetZoom();
        image.hidden = true;
        if (well) well.setAttribute('aria-busy', 'false');
        if (zoom) zoom.disabled = true;
        if (imageStatus) { imageStatus.textContent = 'This image couldn’t load. Open it in a new tab, or read the message below.'; imageStatus.hidden = false; }
      });
      listen(root, 'click', function (event) {
        var trigger = event.target instanceof Element && event.target.closest('[data-fms-open]');
        if (!trigger || !root.contains(trigger)) return;
        var story = stories.get(trigger.getAttribute('data-fms-open'));
        var source = story && blurredImageURL(story.image);
        if (!story || !source || !image) return;
        if (typeof dialog.showModal !== 'function') { window.open(source, '_blank', 'noopener'); return; }
        event.preventDefault();
        opener = trigger;
        var title = dialog.querySelector('[data-fms-viewer-title]');
        var sourceLabel = dialog.querySelector('[data-fms-viewer-source]');
        var transcript = dialog.querySelector('[data-fms-transcript]');
        var context = dialog.querySelector('[data-fms-context]');
        if (title) title.textContent = story.author || 'Customer message';
        if (sourceLabel) sourceLabel.textContent = story.source || 'Customer message';
        if (transcript) transcript.textContent = story.transcript || '';
        if (context) context.textContent = story.context || '';
        if (fullImage) fullImage.href = source;
        dialog.querySelectorAll('details').forEach(function (details) { details.open = false; });
        resetZoom();
        image.hidden = true;
        image.alt = (story.source || 'Customer message') + ' from ' + (story.author || 'a FizzyIQ parent') + ', with personal details blurred';
        if (well) well.setAttribute('aria-busy', 'true');
        if (zoom) zoom.disabled = true;
        if (imageStatus) { imageStatus.textContent = 'Loading customer message…'; imageStatus.hidden = false; }
        image.src = source;
        if (image.complete && image.naturalWidth) imageReady();
        if (!dialog.open) dialog.showModal();
        if (close) close.focus({ preventScroll: true });
      });
      listen(close, 'click', function () { dialog.close(); });
      listen(dialog, 'click', function (event) {
        if (event.target !== dialog) return;
        var rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      });
      listen(dialog, 'close', function () {
        resetZoom();
        if (!disposed && opener && opener.isConnected) opener.focus({ preventScroll: true });
        opener = null;
      });
      listen(zoom, 'click', function () {
        if (!image || !well || !image.naturalWidth) return;
        var enlarged = !well.classList.contains('is-zoomed');
        if (enlarged) {
          var width = Math.max(image.naturalWidth, Math.round(image.getBoundingClientRect().width * 2));
          well.classList.add('is-zoomed');
          image.style.width = width + 'px';
        } else resetZoom();
        zoom.setAttribute('aria-pressed', String(enlarged));
        zoom.textContent = enlarged ? 'Fit image' : 'Zoom in';
        if (guidance) guidance.hidden = !enlarged;
      });
      cleanups.push(function () { if (dialog.open) dialog.close(); });
    }

    var videoCards = Array.from(root.querySelectorAll('[data-fms-video-card]'));
    var playbackRequest = 0;
    function stopVideo(card, restoreFocus) {
      var video = card.querySelector('video');
      if (activePlayback && activePlayback.card === card) { activePlayback = null; playbackRequest++; }
      if (video) { video.pause(); video.hidden = true; }
      card.classList.remove('is-playing', 'has-video-error');
      var error = card.querySelector('[data-fms-video-error]');
      if (error) error.hidden = true;
      var play = card.querySelector('[data-fms-play]');
      if (play) { play.setAttribute('aria-expanded', 'false'); if (restoreFocus && !disposed) play.focus({ preventScroll: true }); }
    }
    function videoFailed(card) {
      var video = card.querySelector('video');
      if (!video) return;
      video.pause();
      video.hidden = true;
      card.classList.remove('is-playing');
      card.classList.add('has-video-error');
      if (activePlayback && activePlayback.card === card) activePlayback = null;
      var error = card.querySelector('[data-fms-video-error]');
      if (error) error.hidden = false;
      var play = card.querySelector('[data-fms-play]');
      if (play) play.setAttribute('aria-expanded', 'false');
    }
    videoCards.forEach(function (card) {
      var video = card.querySelector('video');
      var play = card.querySelector('[data-fms-play]');
      if (!video || !play) return;
      play.setAttribute('aria-expanded', 'false');
      listen(card.querySelector('[data-fms-video-close]'), 'click', function () { stopVideo(card, true); });
      listen(play, 'click', function () {
        if (activePlayback && activePlayback.card !== card) activePlayback.stop(false);
        var request = ++playbackRequest;
        activePlayback = { card: card, stop: function (restore) { stopVideo(card, restore); } };
        var error = card.querySelector('[data-fms-video-error]');
        if (error) error.hidden = true;
        card.classList.remove('has-video-error');
        if (!video.getAttribute('src')) video.src = video.getAttribute('data-src') || '';
        if (video.ended) video.currentTime = 0;
        video.hidden = false;
        video.controls = true;
        video.tabIndex = 0;
        card.classList.add('is-playing');
        play.setAttribute('aria-expanded', 'true');
        var promise = video.play();
        if (promise) promise.then(function () {
          if (disposed || request !== playbackRequest || !activePlayback || activePlayback.card !== card) { video.pause(); return; }
          video.focus({ preventScroll: true });
        }).catch(function () {
          if (!disposed && request === playbackRequest && activePlayback && activePlayback.card === card) videoFailed(card);
        });
      });
      listen(video, 'play', function () {
        document.querySelectorAll('video').forEach(function (other) { if (other !== video && !other.muted && !other.paused) other.pause(); });
      });
      listen(video, 'ended', function () { stopVideo(card, false); });
      listen(video, 'error', function () { if (activePlayback && activePlayback.card === card) videoFailed(card); });
      listen(video, 'keydown', function (event) { if (event.key === 'Escape') { event.preventDefault(); stopVideo(card, true); } });
    });
    if ('IntersectionObserver' in window) {
      var videoObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) { if (entry.intersectionRatio < .15 && activePlayback && activePlayback.card === entry.target) stopVideo(entry.target, false); });
      }, { threshold: [0, .15] });
      videoCards.forEach(function (card) { videoObserver.observe(card); });
      cleanups.push(function () { videoObserver.disconnect(); });
    }
    cleanups.push(function () { videoCards.forEach(function (card) { stopVideo(card, false); }); });

    var filters = Array.from(root.querySelectorAll('[data-fms-filter]'));
    var libraryCards = Array.from(root.querySelectorAll('.fms__library-grid>[data-fms-card]'));
    filters.forEach(function (button) {
      listen(button, 'click', function () {
        var topic = button.getAttribute('data-fms-filter');
        filters.forEach(function (filter) { filter.setAttribute('aria-pressed', String(filter === button)); });
        var count = 0;
        libraryCards.forEach(function (card) {
          var shown = topic === 'all' || card.getAttribute('data-fms-topic') === topic;
          card.hidden = !shown;
          if (shown) count++;
          else if (activePlayback && activePlayback.card === card) stopVideo(card, false);
        });
        var filterStatus = root.querySelector('[data-fms-filter-status]');
        if (filterStatus) filterStatus.textContent = count + (count === 1 ? ' story shown' : ' stories shown');
      });
    });
    instances.set(root, function () {
      disposed = true;
      cleanups.reverse().forEach(function (cleanup) { cleanup(); });
      instances.delete(root);
    });
  }
  function scan(scope) {
    if (scope.matches && scope.matches('[data-fms]')) init(scope);
    scope.querySelectorAll('[data-fms]').forEach(init);
  }
  window.__fizzyMessageStories = { scan: scan };
  scan(document);
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    instances.forEach(function (dispose, root) { if (event.target === root || event.target.contains(root)) dispose(); });
  });
  document.addEventListener('visibilitychange', function () { if (document.hidden && activePlayback) activePlayback.stop(false); });
  window.addEventListener('pagehide', function () { if (activePlayback) activePlayback.stop(false); });
})();
